__turbopack_context__.v({
  "input": "a-i-field-module-scss-module__ipWZWa__input",
  "input-container": "a-i-field-module-scss-module__ipWZWa__input-container",
  "label": "a-i-field-module-scss-module__ipWZWa__label",
  "root": "a-i-field-module-scss-module__ipWZWa__root",
});
